import React, { ReactNode } from "react";

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  hideBottomPadding?: boolean;
  isDark?: boolean;
}

const SectionWrapper = ({
  className,
  children,
  hideBottomPadding,
  isDark,
}: SectionWrapperProps) => {
  return (
    <section
      className={`space-y-10 px-[5%] ${
        hideBottomPadding ? "" : " pb-8 md:pb-16"
      } ${isDark ? "!bg-dark-gray" : ""}  ${className}`}
    >
      {children}
    </section>
  );
};

export default SectionWrapper;
